import React from 'react';
import {NavDropdown} from 'react-bootstrap';

import './Language.scss';

import {
  getLanguage,
  setDefaultLanguage,
  setLanguage,
  setTranslations,
  t,
} from 'react-switch-lang';
import eng from '../../language/eng';
import mne from '../../language/mne.json';

setTranslations({eng, mne});
const lang = localStorage.getItem('language_risk');
if (lang === null) {
  setDefaultLanguage('mne');
} else {
  setDefaultLanguage(lang);
}

export function Settings() {
  function handleSetLanguage(key) {
    setLanguage(key);
    localStorage.setItem('language_risk', getLanguage());
    window.location.reload();
  }

  return (
    <>
      <NavDropdown
        title={t('navbar.language')}
        id="basic-nav-dropdown"
        className="dropdown-menu-right dropdownSidebar links dropdown-settings"
      >
        <NavDropdown.Item onClick={() => handleSetLanguage('mne')}>
          {t('language.mneLat')}
        </NavDropdown.Item>

        <NavDropdown.Item id="eng" onClick={() => handleSetLanguage('eng')}>
          {t('language.english')}
        </NavDropdown.Item>
      </NavDropdown>
    </>
  );
}
